export const getPassportPath = (passportToken: string) =>
  `/lca/product-passport/${passportToken}`;

export const getPassportUrl = (passportToken: string) =>
  `${window.location.origin}${getPassportPath(passportToken)}`;
